export default "__VITE_ASSET__9$cy6NED__"